import { FC } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import styles from './styles.module.scss';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ChartDataLabels);

interface LineChartProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;

  w? : boolean;
}

const LineChart: FC<LineChartProps> = ({ options, data , w }): JSX.Element => {
  const [t] = useTranslation('chart');

  return (
    <div className={styles.line_chart_container}  style={{
      width :  w ? '100%' : ''
    }} >
      <Line
        className={styles.line_chart}
        options={options}
        data={data}
        tabIndex={0}
        aria-label={`${t('lineChartLabel')}`}
      />
    </div>
  );
};

export default LineChart;
